export const educationInfo = [
  {
    institution: "Southeast University",
    title: "B.Sc. in CSE",
    date: "April, 2020",
    description: ["CGPA: 3.59"],
  },
  {
    institution: "Bangladesh Navy College, Dhaka",
    title: "H.S.C (Science)",
    date: "June, 2015",
    description: ["GPA: 5.00"],
  },
  {
    institution: "Shaheed Police Smrity College, Dhaka",
    title: "S.S.C (Science)",
    date: "May, 2013",
    description: ["GPA: 5.00"],
  },
];
